import { androidDispatchers, autoWebViewJs, IPermissionAskResult, IPermissionResult, Manifest, openHtmlShowA11yNodeInfoButton, openHtmlShowA11yNodeInfoWindow, permissionUtils } from "@droid/android";
import { documentHiddenData, Log, toProxy, useProxyWatch, useTranslation } from "@fanfanlo";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ulid } from "ulid";

//interface 

const fileLog = new Log(false, 'open-a11y-node-button.tsx')
fileLog.isChildrenPaused = true;
fileLog.isPaused = true;
const data = toProxy({opened:false})
async function onClick() {

    if(data.opened)return;
    const eventType = "a11yNodeSelectActionItem"
    const selectEventIndex = autoWebViewJs.shellListen(androidDispatchers.WebViewJsDispatcher.name, eventType, eventType, false, onSelectNode)
    function onSelectNode(s: string) {
        clear()
        autoWebViewJs.clipboardSetText(s)
        // const info: IA11yNodeInfo = JSON.parse(s)
        // console.log('fffffffffffffff', s)
    }
    function clear(){
        data.opened = false;
        autoWebViewJs.shellRemoveListen(androidDispatchers.WebViewJsDispatcher.name, selectEventIndex);
        autoWebViewJs.shellRemoveListen(androidDispatchers.Window.name, exitWindowIndex);
        if(exitWebviewJsIndex){
            autoWebViewJs.removeListen(androidDispatchers.Window.name, parseInt(exitWebviewJsIndex));
        }
    }
    const windowId = ulid()
    openHtmlShowA11yNodeInfoButton(eventType, windowId)
    data.opened = true;
    const et = `window-${windowId}-dismiss`
    const {javaResultString:exitWebviewJsIndex, errMsg} = autoWebViewJs.listen(androidDispatchers.Window.name, et, et, true)
    if(errMsg){
        throw new Error(errMsg)
    }
    const exitWindowIndex = autoWebViewJs.shellListen(androidDispatchers.Window.name, et, et, true, ()=>{
        clear()
    });
}


export function OpenA11yNodeButton() {
    const uiLog = fileLog.sub(false, 'OpenA11yNodeButton_ui')
    uiLog.pause = true;
    const { t } = useTranslation('homepage/components/a11y/content')
    const [isHidden] = useProxyWatch(documentHiddenData, 'isHidden', documentHiddenData.isHidden);
    const [isWaitingPermissions, setIsWaitingPermissions] = useState(false);
    function checkPermissions(){
        const script = `
        com.fanfanlo.lib.permission.PermissionRequestManager.checkPermissions([
            "Manifest.permission.CAMERA",
            "android.permission.SYSTEM_ALERT_WINDOW",
            "android.permission.BIND_ACCESSIBILITY_SERVICE"
        ]);
        `
        const {javaResultData, javaResultString, errMsg} = autoWebViewJs.callScript<IPermissionResult>(script);
        uiLog.log('checkPermissions_fn javaResultString=', javaResultString, errMsg, javaResultData);
        uiLog.log('checkPermissions_fn javaResultData2 =', JSON.stringify(javaResultData))
        uiLog.log('checkPermissions_fn javaResultData3 =', javaResultData)
        uiLog.log('checkPermissions_fn javaResultData4 =', typeof javaResultData)
        uiLog.log('checkPermissions_fn javaResultData5 =', javaResultData?.grantResults[0], 'and typeof', typeof javaResultData?.grantResults[0])
        if(errMsg){
            throw new Error(errMsg)
        }
    }
    useEffect(()=>{
        if(isHidden){
            uiLog.log('use effect isHidden', isHidden)
            return;
        }
        if(!isWaitingPermissions){
            uiLog.log('use effect isWaitingPermissions', isWaitingPermissions)
            return;
        }

        
    }, [isHidden, isWaitingPermissions])
    const [opened] = useProxyWatch(data, 'opened', data.opened);
    function onClick(){
        checkPermissions()
    }
    function onAskPermissionComplete(stoped:boolean, granted:boolean, result?:IPermissionAskResult){
        uiLog.log('onAskPermissionComplete_fn stoped=', stoped, 'granted=', granted, 'result=', JSON.stringify(result))
        if(!granted){
            toast.error("有未授权的权限，所以无法运行。\n请再次点击按钮运行授权并同意赋权后才能继续执行操作。");
            return;
        }
        
        const eventType = ulid();// "a11yNodeSelectActionItem";
        const windowId = ulid()
        uiLog.log('onAskPermissionComplete_fn eventType=', eventType, 'windowId=', windowId)
        openHtmlShowA11yNodeInfoWindow(eventType, windowId)
    }
    function askingPermissions(){
        const eventType = ulid();// "a11yNodeSelectActionItem";
        const windowId = ulid()
        uiLog.log('askingPermissions_fn eventType=', eventType) 
        const res = permissionUtils.askPermissions([
            // Manifest.Permission.CAMERA,
            Manifest.Permission.SYSTEM_ALERT_WINDOW,
            Manifest.Permission.BIND_ACCESSIBILITY_SERVICE
        ], eventType, onAskPermissionComplete);
        uiLog.log('askingPermissions_fn res=', res)
        if(res.isGranted){
            onAskPermissionComplete(false, true);
        }
    }
    return <>
        <Button variant="contained" onClick={askingPermissions} disabled={false} data-testid="OpenA11yNodeButton__askPermissionsButton__01JG2B0079" data-test-comment="请求无障碍权限按钮，点击后请求系统无障碍服务权限，获得权限后可以选择无障碍节点">{t("open-a11y-node-button.btnName")}</Button>
    </>
}